import React, { FC, useEffect } from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Box, fade, Button } from '@material-ui/core';
import Typo from '../../Components/Typo';
import StyledLabel from '../../Components/StyledLabel';
import { THEME_PALETTE } from '../../Theme/themeValues';
import gsap from 'gsap';
import { reverse } from 'lodash';
import { uniqueId } from 'lodash';
import BorderedAvatar from '../../Components/BorderedAvatar';
import PopperButton from '../../Components/PopperButton';
import { useMediaQuery } from '../../Hooks/useMediaQuery';


export type TTestimonial = {
    name: string;
    designation: string;
    company: string;
    text: string;
    image: string;
}

export interface TestimonialCardProps {
    item: TTestimonial
}



const getAssetUrl = (asset: string) => {
    try {
        return require('../../Assets/testimonial/' + asset)
    } catch (error) {
        return ''
    }
}


const TestimonialCard: FC<TestimonialCardProps> = (props) => {
    const classes = useStyles();
    const id = uniqueId('card');
    const { isDeviceSm } = useMediaQuery();
    const { item } = props;
    const text1 = item.text


    useEffect(() => {
        gsap.timeline({
            scrollTrigger: {
                trigger: `.${classes.container}`,
                toggleActions: 'restart pause',
            }
        })
            .fromTo(`.${classes.container}`, { scale: 0.8 }, { scale: 1, duration: 1.5 })
            .fromTo(`.testimonial-avatar`, { scale: 0 }, { stagger: 0.2, scale: 1 }, '-=1')
            .fromTo(`.testimonial-user`, { position: 'relative', left: 50, opacity: 0 }, { left: 0, opacity: 1, stagger: 0.2 }, '-=2')

        gsap.to(`#${`${id}-text1`}`, {
            scrollTrigger: {
                trigger: `.${classes.container}`,
                toggleActions: 'restart pause',
            }, duration: 1.5, text: text1, ease: "power2.easeOut"
        })
        // gsap.to(`#${`${id}-text2`}`, {
        //     scrollTrigger: {
        //         trigger: `.${classes.container}`,
        //         toggleActions: 'restart pause',
        //     }, duration: 1.5, text: text2, ease: "power2.easeOut"
        // })
    }, [])

    return (
        <Box width={isDeviceSm ? "70vw" : "410px"}>
            <Box className={classes.container}>
                <Typo className={classes.quote} variant="h1">"</Typo>
                <Typo id={`${id}-text1`}>
                    {reverse(item.text.split('')).join('')}
                </Typo>
                <br />

                <Box flex={1} />
                {/* <Box display='flex'>
                    <Box flex={1} />
                    <Box mr={-2}>
                        <Button color='primary'>PLAY VIDEO</Button>
                    </Box>
                </Box> */}
            </Box>
            <Box mt={-3} ml={isDeviceSm ? 3 : 6} display="flex" flexDirection='row' alignItems={isDeviceSm ? 'flex-start' : 'flex-end'}>
                <div className="testimonial-avatar" >
                    <BorderedAvatar radius={isDeviceSm ? 38 : 48} src={getAssetUrl(item.image)} />
                </div>
                <Box ml={2} className='testimonial-user'>
                    <Typo weight='medium'>{item.name}</Typo>
                    <Typo variant='body2' weight='medium'>{item.designation}</Typo>
                    <Typo variant='body2' weight='medium'>{item.company}</Typo>
                </Box>
            </Box>
        </Box>
    )
}

const useStyles = makeStyles<Theme, any>((theme) => ({
    container: {
        position: 'relative',
        // height: 380,
        padding: '40px 56px',
        borderRadius: '60px 0px 60px 0px',
        backgroundColor: fade(theme.palette.common.white, 0.5),
        [theme.breakpoints.down('sm')]: {
            padding: '20px 26px',
        }

    },
    quote: {
        color: THEME_PALETTE.others.venziYellow,
        position: 'absolute',
        top: -22,
        left: -4,
        fontSize: 120,
        textShadow: `2px 2px ${fade(theme.palette.common.black, 0.29)}`,
        [theme.breakpoints.down('sm')]: {
            fontSize: 80
        }
    }
}));

export default TestimonialCard;